import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { TimingSlotsModel } from '../../models/timing-slots.model';

// services
import API from '../../services/api';

import timingQueryKeys from './_queryKeys';

const getSlots = async (): Promise<TimingSlotsModel[]> => {
    const { data } = await API.getTimingSlots();
    return data;
};

export default function useTimingSlots() {
    return useQuery<TimingSlotsModel[], BaseError>({
        queryKey: timingQueryKeys.timingSlots,
        queryFn: () => getSlots(),
    });
}
